import { render, staticRenderFns } from "./CarBusiness.vue?vue&type=template&id=1960130c&"
import script from "./CarBusiness.vue?vue&type=script&lang=js&"
export * from "./CarBusiness.vue?vue&type=script&lang=js&"
import style0 from "./CarBusiness.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports